// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3qohd","name":"Header_name__3w6nX","birthday":"Header_birthday__8h3Vv","skeleton":"Header_skeleton__1V7w3"};